// src/components/AboutSection.js
import React from "react";
import { Link } from "react-router-dom";
import BannerImg from "../../../../assets/img/banner.jpg";
import "../../../../assets/lib/root.css";
import "./styles.css";
import useScrollReveal from "../../../../assets/hooks/useScrollReveal/useScrollReveal";
const AboutSection = ({ headerHeight }) => {
  // Danh sách các dịch vụ chi tiết theo yêu cầu
  const servicesList = [
    "Lắp đặt điều hòa, máy lạnh dân dụng & công nghiệp",
    "Thi công ống gió – hệ thống thông gió – hút mùi – HVAC",
    "Gia công – lắp đặt cơ khí, giá đỡ, bản lề, cửa, kết cấu",
    "Thi công điện nước, hệ thống cấp – thoát nước",
  ];
  // Tính toán style động
  const dynamicStyle = {
    paddingTop: `1rem`, // Thêm 50px buffer cho đẹp
  };
  console.log("HEIGHT", dynamicStyle);
  // Refs cho từng phần tử con
  const [titleRef, isTitleVisible] = useScrollReveal({ threshold: 0.5 });
  const [textRef, isTextVisible] = useScrollReveal({ threshold: 0.5 });
  const [buttonRef, isButtonVisible] = useScrollReveal({ threshold: 0.5 });

  const getRevealClass = (isVisible) =>
    `scroll-reveal-item ${isVisible ? "is-visible" : ""}`;
  return (
    <section
      className="about-us"
      style={{ backgroundImage: `url(${BannerImg})`, ...dynamicStyle }}
    >
      {}
      <div className={`about-us__content ${getRevealClass(isTitleVisible)}`}>
        {}
        <h2 className="about-us__title--new" ref={titleRef}>
          HABAKO M&E
        </h2>

        {}
        <ul
          className={`about-us__services-list ${getRevealClass(isTextVisible)}`}
          ref={textRef}
        >
          {servicesList.map((service, index) => (
            <li key={index} className="service-item">
              ✅ {service}
            </li>
          ))}
        </ul>

        {}
        <Link
          to="/lien-he"
          ref={buttonRef}
          className={`${getRevealClass(isButtonVisible)} about-us__cta-button`}
        >
          LIÊN HỆ ĐỂ ĐƯỢC TƯ VẤN
        </Link>
      </div>
    </section>
  );
};

export default AboutSection;
